/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type Stream_stream$ref: FragmentReference;
export type Stream_stream = {|
  +id: string,
  +title: ?string,
  +slug: ?string,
  +video: ?string,
  +state: ?string,
  +topics: ?$ReadOnlyArray<?{|
    +id: string,
    +name: ?string,
  |}>,
  +videoFile: ?{|
    +id: string,
    +filename: ?string,
    +description: ?string,
  |},
  +preview: ?{|
    +id: string,
    +filename: ?string,
  |},
  +screen: ?boolean,
  +rating: ?string,
  +active: ?boolean,
  +linkedArticles: ?$ReadOnlyArray<?{|
    +id: string,
    +title: ?string,
  |}>,
  +description: ?string,
  +availableAt: ?string,
  +$refType: Stream_stream$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "filename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "Stream_stream",
  "type": "Stream",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "slug",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "video",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "state",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "topics",
      "storageKey": null,
      "args": null,
      "concreteType": "Topic",
      "plural": true,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "videoFile",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaFile",
      "plural": false,
      "selections": [
        v0,
        v2,
        v3
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "preview",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaFile",
      "plural": false,
      "selections": [
        v0,
        v2
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "screen",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "rating",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "active",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkedArticles",
      "storageKey": null,
      "args": null,
      "concreteType": "Article",
      "plural": true,
      "selections": [
        v0,
        v1
      ]
    },
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "availableAt",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bdc374f46750f205e76d37d377ac0d67';
module.exports = node;



// WEBPACK FOOTER //
// src/components/streams/__generated__/Stream_stream.graphql.js